import forEach from 'lodash-es/forEach';
import set from 'lodash-es/set';
import filter from 'lodash-es/filter';
import map from 'lodash-es/map';
import get from 'lodash-es/get';
import { addScript } from '../../bundles/helpers/add-script';
import $ from 'jquery';

const ClassName = {
  BLOCK: 'form-control',
  SELECT_OPTION: 'form-control__option',
  SELECT_DROPDOWN: 'form-control__dropdown',
  SELECT_DROPDOWN_LIST: 'select2-results__options',
  SELECT_CONTAINER: 'select2-container',
  SELECT_CLEAR: 'select2-selection__clear',
};

class FormControl {
  constructor(elem) {
    this.block = elem;
    this.selectedFields = [];

    // Bind functions;
    this.init = this.init.bind(this);
    this.load = this.load.bind(this);
    this.initSelect = this.initSelect.bind(this);
    this.updateSelectedFieldsListener = this.updateSelectedFieldsListener.bind(this);

    this.init();
  }

  async load() {
    if ($ && !$.fn.select2) {
      await addScript(PUBLIC_PATH + 'vendor/select2/select2.vendor.js');
      await addScript(PUBLIC_PATH + 'vendor/select2/ru.vendor.js');
    }
  }
    init() {
    switch (this.block.tagName) {
      case 'SELECT':
        this.initSelect();
        break;
      default:
    }
  }

  async initSelect(selectedList) {
    if (!$.fn.select2) await this.load();
    if (selectedList) this.selectedFields = selectedList;
    const $block = $(this.block);
    const url = $block.attr('url');
    const formatState = (state) => {
      if (!state.id) return state.text;
      return this.selectedFields.includes(state.id) ? $(`<span class="disabled" data-id="${state.id}">${state.text}</span>`)
        : $(`<span data-id="${state.id}">${state.text}</span>`);
    };
    // Init
    if (url) {
      this.updateSelectedFieldsListener();
      const multiple = $block.attr('multiple');
      const placeholder = $block.attr('placeholder');
      const defaultOptions = {
        ajax: url ? {
          url: url,
          data: function(params) {
            return {
              name: params.term,
            };
          },
          processResults: function(data) {
            return {
              results: map(get(data, 'products', data), ({id, name, price, stock}) => ({
                id,
                text: name,
                price,
                stock,
              })),
            };
          },
        } : null,
        multiple,
        minimumInputLength: 3,
        maximumSelectionLength: 10,
        width: 'style',
        language: 'ru',
        allowClear: false,
        clear: false,
        placeholder: placeholder,
        minimumResultsForSearch: Infinity,
        containerCssClass: `${ClassName.BLOCK}`,
        selectionCssClass: `${ClassName.BLOCK}`,
        dropdownCssClass: ClassName.SELECT_DROPDOWN,
        dropdownParent: this.block.dataset.parent ? $(this.block.dataset.parent) : $(document.body),
        templateResult: formatState,
      };
      $block.select2(defaultOptions);
    }
    return $block;
  }

  updateSelectedFieldsListener() {
    document.addEventListener('iv.update.selected.list', (event) => {
      this.selectedFields = event.detail;
    });
  }

  static getAllBlocks() {
    return Array.from(document.getElementsByClassName(ClassName.BLOCK));
  }

  static getAllInstances() {
    return map(filter(FormControl.getAllBlocks(), ({ins}) => ins), (item) => item.ins);
  }

  static initAllBlocks() {
    let Blocks = FormControl.getAllBlocks();
    forEach(Blocks, (block) => {
      if (block.ins) return;
      block.ins = new FormControl(block);
    });
  }
}

// Инициашизация;
FormControl.initAllBlocks();

// Экспорт;
set(window, ['Block', 'FormControl'], FormControl);
export default FormControl;
